import { render } from "./ButtonRank112.vue?vue&type=template&id=2954c7ee&scoped=true"
const script = {}

import "./ButtonRank112.vue?vue&type=style&index=0&id=2954c7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2954c7ee"]])

export default __exports__